import type { BadgeVariant } from '../components/ui/Badge'

export const LEGAL_STATUSES = [
  'Собственный дизайн',
  'Официальная лицензия',
  'Не официальная лицензия',
  'Требует проверки',
  'Запрещен',
] as const

export type LegalStatus = (typeof LEGAL_STATUSES)[number]

const LEGACY_ALIASES: Record<string, LegalStatus> = {
  Собственный: 'Собственный дизайн',
  Разрешен: 'Официальная лицензия',
  Разрешён: 'Официальная лицензия',
  Запрещён: 'Запрещен',
}

export function normalizeLegalStatus(status?: string | null): LegalStatus {
  const value = String(status || '').trim()
  if ((LEGAL_STATUSES as readonly string[]).includes(value)) return value as LegalStatus
  return LEGACY_ALIASES[value] || 'Требует проверки'
}

export function legalStatusDotClass(status?: string | null): string {
  switch (normalizeLegalStatus(status)) {
    case 'Собственный дизайн':
    case 'Официальная лицензия':
      return 'bg-green-500'
    case 'Не официальная лицензия':
    case 'Требует проверки':
      return 'bg-yellow-500'
    case 'Запрещен':
      return 'bg-red-500'
  }
}

export function legalStatusTextClass(status?: string | null): string {
  switch (normalizeLegalStatus(status)) {
    case 'Собственный дизайн':
    case 'Официальная лицензия':
      return 'text-green-600 dark:text-green-400'
    case 'Не официальная лицензия':
    case 'Требует проверки':
      return 'text-yellow-600 dark:text-yellow-400'
    case 'Запрещен':
      return 'text-red-600 dark:text-red-400'
  }
}

export function legalStatusBadgeVariant(status?: string | null): BadgeVariant {
  switch (normalizeLegalStatus(status)) {
    case 'Собственный дизайн':
    case 'Официальная лицензия':
      return 'green'
    case 'Не официальная лицензия':
    case 'Требует проверки':
      return 'yellow'
    case 'Запрещен':
      return 'red'
  }
}
